import React from "react";
import ReactDOM from "react-dom";

import * as QPlayerSVGElement from '../QPlayerSVGElement';

declare global {
    // eslint-disable-next-line no-unused-vars
    namespace JSX {
        // eslint-disable-next-line no-unused-vars
        interface IntrinsicElements {
            'qplayer-widget-container': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
            'qplayer-embed': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
        }
    }
}

const WidgetComponent = (props: any) => {
    // Prepare attributes from container dataset before rendering
    const dataAttributes: Record<string, string> = {};
    Object.keys(props.container?.dataset || {}).forEach(key => {
        if (key.startsWith('qplayer')) {
            const attrKey = 'data-' + key.replace(/([A-Z])/g, '-$1').toLowerCase();
            dataAttributes[attrKey] = props.container?.dataset[key];
        }
    });

    return ReactDOM.createPortal(
        <qplayer-widget-container data-qplayer-widget-container-key={`${props.widgetKey}-container`}>
            <qplayer-embed
                style={{ width: "100%", height: "100%" }}
                data-qplayer-inline="off"
                data-qplayer-autoplay="true"
                data-qplayer-hide-play-button="true"
                data-qplayer-key={props.widgetKey}
                data-qplayer-from-qplayer-widget="true"
                {...dataAttributes}
            >

            </qplayer-embed>
            <div className="qplayer__play-corner-icon" aria-hidden={true}>
                <QPlayerSVGElement.Play color="#ffffff" width={15} height={15}/>
            </div>
        </qplayer-widget-container>,
        document.body
    );
};

export default WidgetComponent;